module.exports = __webpack_public_path__ + "media/images/pr_detail/2-5a04de31373388292caf39f87d33ccd8.png";